import { render, staticRenderFns } from "./SimpleBox.vue?vue&type=template&id=bb09312a&scoped=true&"
import script from "./SimpleBox.vue?vue&type=script&lang=js&"
export * from "./SimpleBox.vue?vue&type=script&lang=js&"
import style0 from "./SimpleBox.vue?vue&type=style&index=0&id=bb09312a&prod&lang=scss&scoped=true&"
import style1 from "./SimpleBox.vue?vue&type=style&index=1&id=bb09312a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb09312a",
  null
  
)

export default component.exports